module.exports = __webpack_public_path__ + "img/20210929.bca9ba18.png";